import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';  // Import useNavigate
import axios from 'axios';
import { FaClock, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { MdErrorOutline } from "react-icons/md";
import { AGENT_CHANGE_URL, CURRENT_USER_DATA_URL, CITY_SUBURB_SUGGESTION_URL, LAST_REQUEST_STATUS, CANCEL_AGENT_REQUEST } from '../constants'


const EditAgentDetails = () => {
    const [activeTab, setActiveTab] = useState('Contact');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editRequest, setEditRequest] = useState(null);
    const [processingAgentIDs, setProcessingAgentIDs] = useState([]);
    const [initialFormData, setInitialFormData] = useState({});

    const [popUpMessage, setPopUpMessage] = useState({ type: '', text: '' });

    const getStatusConfig = (status) => {
        switch (status) {
            case 'pending':
            return {
                icon: FaClock,
                color: 'text-amber-600 dark:text-amber-500',
                bgColor: 'bg-amber-50',
                borderColor: 'border-amber-200',
                label: 'Pending Review'
            };
            case 'approved':
            return {
                icon: FaCheckCircle,
                color: 'text-green-600',
                bgColor: 'bg-green-50',
                borderColor: 'border-green-200',
                label: 'Approved'
            };
            case 'rejected':
            return {
                icon: FaTimesCircle,
                color: 'text-red-600',
                bgColor: 'bg-red-50',
                borderColor: 'border-red-200',
                label: 'Rejected'
            };
            case 'cancelled':
            return {
                icon: FaTimesCircle,
                color: 'text-orange-600',
                bgColor: 'bg-orange-50',
                borderColor: 'border-orange-200',
                label: 'Cancelled'
            };
            default:
            return {
                icon: FaClock,
                color: 'text-gray-600',
                bgColor: 'bg-gray-50',
                borderColor: 'border-gray-200',
                label: 'Unknown'
            };
        }
        };


    const [formData, setFormData] = useState({

        AgentID: 0,
        Phone: '',
        Fax: '',
        Mobile: '',
        Email: '',


        LocalAddressLine1: '',
        LocalAddressLine2: '',
        LocalAddressLine3: '',
        LSuburb: '',
        LSuburbID: 0,
        LState: '',
        LCountry: '',
        LPostCode: '',


        MailingAddressLine1: '',
        MailingAddressLine2: '',
        MailingAddressLine3: '',
        MSuburb: '',
        MSuburbID: 0,
        MState: '',
        MPostCode: '',
        MCountry: ''

    });


    // **********************************
    const [localSuburbSuggestions, setLocalSuburbSuggestions] = useState([]);
    const [mailingSuburbSuggestions, setMailingSuburbSuggestions] = useState([]);
    const [showLocalSuggestions, setShowLocalSuggestions] = useState(false);
    const [showMailingSuggestions, setShowMailingSuggestions] = useState(false);
    // *************


    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        // ************************
        if (name === 'LSuburb' && value.length > 2) {
            fetchSuburbSuggestions(value, setLocalSuburbSuggestions, setShowLocalSuggestions);
        } else if (name === 'MSuburb' && value.length > 2) {
            fetchSuburbSuggestions(value, setMailingSuburbSuggestions, setShowMailingSuggestions);
        } else if (value.length == 0) {
            setLocalSuburbSuggestions([]);
            setMailingSuburbSuggestions([])
        };

        // **********************
    };

    // *******************************
    const fetchSuburbSuggestions = async (query, setSuggestions, setShowSuggestions) => {
        try {
            const response = await axios.get(CITY_SUBURB_SUGGESTION_URL + query, {
                headers: {
                    "ngrok-skip-browser-warning": true,
                }
            });  /*(`${CITY_SUBURB_SUGGESTION_URL}?query=${query}`)*/
            const suggestions = Array.isArray(response.data) ? response.data : []; // Ensure the response is an array

            setSuggestions(suggestions);
            setShowSuggestions(suggestions.length > 0); // Only show suggestions if there are any
        } catch (err) {
            console.error('Error fetching suburb suggestions:', err);
            setShowSuggestions(false); // Hide suggestions on error
        }
    };

    const handleSuburbSelect = (suburb, isLocal) => {
        if (isLocal) {
            setFormData({
                ...formData,
                LSuburb: suburb.name,
                LSuburbID: suburb.suburbID,
                LPostCode: suburb.postCode,
                LState: suburb.state,
                LCountry: suburb.country
            });
            setShowLocalSuggestions(false); // Hide suggestions after selection
        } else {
            setFormData({
                ...formData,
                MSuburb: suburb.name,
                MSuburbID: suburb.suburbID,
                MPostCode: suburb.postCode,
                MState: suburb.state,
                MCountry: suburb.country
            });
            setShowMailingSuggestions(false); // Hide suggestions after selection
        }
    };
    // *******************************************

    const checkExistingRequest = async () => {
        try {
            const res = await fetch(LAST_REQUEST_STATUS, {
                headers: { "ngrok-skip-browser-warning": true }
                });

                if (!res.ok) {
                    console.warn("No recent request found or server error");   
                    return;
                }

                const req = await res.json();

                if (req && req.active === true) {
                    const status =
                        req.status === 0 ? 'pending' :
                        req.status === 1 ? 'rejected' :
                        req.status === 2 ? 'approved' : 
                        req.status === 3 ? 'cancelled' : 'unknown';

                    if (req.status == 0) {
                        setEditRequest({
                            id: req.agentChangeInformationID,
                            status,
                            submittedDate: req.createDate
                        });
                    }

                    const key = `showLastReqStatus_${req.agentChangeInformationID}`;

                    if (req.status !== 0 && localStorage.getItem(key) === null) {
                        Object.keys(localStorage).forEach((k) => {
                        if (k.startsWith("showLastReqStatus_")) localStorage.removeItem(k);
                        });
                        localStorage.setItem(key, "false");
                    }

                    const showStatus = (req.status === 1 || req.status === 2) && localStorage.getItem(key) !== "true";

                    if (showStatus) {
                        if (req.status === 2) setPopUpMessage({ type: 'success', text: "Your last request was Approved" });
                        if (req.status === 1) setPopUpMessage({ type: 'error', text: "Your last request was Declined" });
                    }
                }
            } 
            catch (err) {
            console.error("Error checking last request:", err);
        }
    };

    const handleCancelRequest = async () => {
        if (!editRequest?.id) {
            setPopUpMessage({ type: 'error', text: 'Unable to cancel: request id not found.' });
            return;
        }

        try {
            await axios.post(`${CANCEL_AGENT_REQUEST}/${editRequest.id}`, null, {
                headers: { 'ngrok-skip-browser-warning': true }
            });

            setPopUpMessage({ type: 'success', text: 'Request cancelled successfully.' });
            setEditRequest(null);
            await checkExistingRequest();

        } catch (err) {
            setPopUpMessage({ type: 'error', text: 'Cancel failed. Please try again.' });
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(CURRENT_USER_DATA_URL, {
                    headers: {
                        "ngrok-skip-browser-warning": true,
                    }
                });
                if (!response.ok) {
                    throw new Error('Faield to fetch data')
                }
                const res = await response.json();
                const data = res.PendingReqDtl ?? res.agentDetail;

                setFormData({

                    AgentID: data.agentID,
                    Phone: data.localPhoneNumber,
                    Fax: data.fax,
                    Mobile: data.mobile,
                    Email: data.email,


                    LocalAddressLine1: data.localAddressLine1,
                    LocalAddressLine2: data.localAddressLine2,
                    LocalAddressLine3: data.localAddressLine3,
                    LSuburb: data.lSuburb,
                    LSuburbID: data.localSuburbID,
                    LState: data.lState,
                    LCountry: data.lCountry,
                    LPostCode: data.lPostCode,


                    MailingAddressLine1: data.mailingAddressLine1,
                    MailingAddressLine2: data.mailingAddressLine2,
                    MailingAddressLine3: data.mailingAddressLine3,
                    MSuburb: data.mSuburb,
                    MSuburbID: data.mailingSuburbID,
                    MState: data.mState,
                    MPostCode: data.mPostCode,
                    MCountry: data.mCountry

                });

                setInitialFormData({
                    AgentID: data.agentID,
                    Phone: data.localPhoneNumber,
                    Fax: data.fax,
                    Mobile: data.mobile,
                    Email: data.email,


                    LocalAddressLine1: data.localAddressLine1,
                    LocalAddressLine2: data.localAddressLine2,
                    LocalAddressLine3: data.localAddressLine3,
                    LSuburb: data.lSuburb,
                    LSuburbID: data.localSuburbID,
                    LState: data.lState,
                    LCountry: data.lCountry,
                    LPostCode: data.lPostCode,


                    MailingAddressLine1: data.mailingAddressLine1,
                    MailingAddressLine2: data.mailingAddressLine2,
                    MailingAddressLine3: data.mailingAddressLine3,
                    MSuburb: data.mSuburb,
                    MSuburbID: data.mailingSuburbID,
                    MState: data.mState,
                    MPostCode: data.mPostCode,
                    MCountry: data.mCountry
                });
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }

            await checkExistingRequest();
        };
        fetchData()
    }, []);


    const handleSubmit = (e) => {
        e.preventDefault();

        if (JSON.stringify(formData) === JSON.stringify(initialFormData)) {
            setPopUpMessage({ type: 'error', text: 'No changes found.' });
            return;
        }

        if (!formData.LSuburb || formData.LSuburb.trim() === "") {
            setPopUpMessage({ type: 'error', text: 'Local Suburb must be entered.' });
            return;
        }

        // validations
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^\d{10,15}$/;;

        if (!emailRegex.test(formData.Email)) {
            setPopUpMessage({ type: 'error', text: 'Enter a valid email address' });
            return;
        }

        if (formData.Mobile && !mobileRegex.test(formData.Mobile)) {
            setPopUpMessage({ type: 'error', text: 'Enter a valid mobile number' });
            return;
        }

        // Create a new object for formData with required fields converted to integers
        const requestData = {
            ...formData,
            AgentID: parseInt(formData.AgentID, 10),  // Convert AgentID to an integer
            LSuburbID: parseInt(formData.LSuburbID, 10),  // Convert LSuburbID to an integer
            MSuburbID: parseInt(formData.MSuburbID, 10),  // Convert MSuburbID to an integer
        };

        if (processingAgentIDs.includes(requestData.AgentID)) {
            setPopUpMessage({ type: 'error', text: "Your request is already in process." });
            return;
        }

        axios.post(AGENT_CHANGE_URL, requestData, {
            headers: {
                'ngrok-skip-browser-warning': true
            }
        })
        .then(res => {
            const id = res.data.agentChangeInformationId;
            const createDate = res.data.createDate;
            setEditRequest({
                id,
                status: 'pending',
                submittedDate: createDate ? new Date(createDate).toLocaleDateString('en-AU') : ''
            });
            setPopUpMessage({ type: 'success', text: "Agent update request submitted successfully." });
            checkExistingRequest();
        })
        .catch(err => {
            setPopUpMessage({ type: 'error', text: "Your request is already in process." });
        });
    };

    const statusConfig = editRequest ? getStatusConfig(editRequest.status) : null;
    const StatusIcon = statusConfig?.icon;
    const hasPendingRequest = editRequest && editRequest.status === 'pending';

    return (
        <>
            {editRequest && statusConfig && (
                <div className={`rounded-lg shadow-sm border-2 overflow-hidden my-6 bg-white dark:bg-white/5 ${statusConfig.borderColor} dark:border-neutral-700`}>
                    <div className={`px-6 py-4 border-b flex justify-between ${statusConfig.bgColor} ${statusConfig.borderColor} dark:bg-white/5 dark:border-neutral-700`}>
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 rounded-lg shadow-sm flex items-center justify-center flex-shrink-0 bg-white dark:bg-neutral-900/40">
                                <StatusIcon className={`w-6 h-6 ${statusConfig.color}`} />
                            </div>

                            <div className="flex-1">
                                <div className="flex items-center gap-2 mb-1">
                                    <span className={`px-2 py-1 rounded text-xs font-medium border ${statusConfig.bgColor} ${statusConfig.color} ${statusConfig.borderColor} dark:bg-white/10 dark:border-neutral-700`}>
                                        {statusConfig.label.toUpperCase()}
                                    </span>
                                </div>

                                <p className="text-sm text-gray-600 dark:text-neutral-300 mt-2">
                                    {editRequest.submittedDate ? <span>Request submitted on {editRequest.submittedDate}</span> : null}
                                </p>
                            </div>
                        </div>
                        <div>
                            <button type="button" onClick={handleCancelRequest} className="rounded-lg text-sm px-4 py-2 border border-red-300 text-red-600 hover:bg-red-100 dark:border-red-500/40 dark:text-red-300 dark:hover:bg-red-500/20">
                                Cancel Request
                            </button>
                        </div>
                    </div>

                    {hasPendingRequest && (
                        <div className="px-6 py-3 border-t bg-white dark:bg-white/5 border-gray-200 dark:border-neutral-700">
                            <div className="flex items-center justify-between gap-4">
                                <div className="flex items-center gap-2 text-sm text-amber-700 dark:text-amber-300">
                                    <MdErrorOutline className="w-4 h-4" />
                                    <span>Your request is being reviewed. You cannot submit a new request until this one is processed.</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
            <div className="mx-auto p-6 bg-white dark:bg-white/5 text-gray-900 dark:text-gray-100 rounded-md mt-4 shadow-md border border-gray-200 dark:border-neutral-700">
                <h2 className="text-2xl font-semibold mb-4">Edit Agent Details</h2>

                {/* popUpMessage */}
                {popUpMessage.text && (
                    <div className="fixed top-4 right-4 z-50 mt-10 mr-4 max-w-sm w-full">
                        <div
                            className={`border px-4 py-3 rounded relative shadow-md ${
                                popUpMessage.type === 'success'
                                    ? 'bg-green-100 border-green-400 text-green-700'
                                    : 'bg-red-100 border-red-400 text-red-700'
                            }`}
                            role="alert"
                        >
                            <span className="block sm:inline">{popUpMessage.text}</span>
                            <button
                                className="absolute top-0 bottom-0 right-0 px-4 py-3"
                                onClick={() => setPopUpMessage({ type: '', text: '' })}
                            >
                                <span className={popUpMessage.type === 'success' ? 'text-green-700' : 'text-red-700'}>
                                    &times;
                                </span>
                            </button>
                        </div>
                    </div>
                )}

                {hasPendingRequest && (
                    <div className="flex justify-end my-1 mr-1 rounded-md text-amber-600 dark:text-amber-200 text-sm">
                        *Viewing details from the pending request
                    </div>
                )}

                {/* Tabs for Navigation */}
                <div className="border-b border-gray-300 dark:border-gray-700 mb-4">
                    <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    {['Contact', 'Local', 'Mailing'].map((tab) => (
                        <button
                        key={tab}
                        className={`py-4 px-1 text-sm font-medium border-b-2 transition-colors
                            ${activeTab === tab
                            ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                            : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-blue-500 dark:hover:text-blue-400'}`}
                        onClick={() => handleTabChange(tab)}
                        >
                        {tab === 'Contact' ? 'Contact Information' :
                            tab === 'Local' ? 'Local Address' : 'Mailing Address'}
                        </button>
                    ))}
                    </nav>
                </div>

                {/* Form Section */}
                <form onSubmit={handleSubmit}>
                    {activeTab === 'Contact' && (
                        <div>
                            {/* Contact Information Form */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                {/* <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Agent ID</label>
                                    <input
                                        type="number"
                                        name="AgentID"
                                        value={formData.AgentID}
                                        onChange={handleChange}
                                        placeholder="Agent ID"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"

                                    />
                                </div> */}



                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Phone</label>
                                    <input
                                        type="varchar"
                                        name="Phone"
                                        disabled={hasPendingRequest}
                                        value={formData.Phone}
                                        onChange={handleChange}
                                        placeholder="Phone"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                    />
                                </div>


                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Mobile No</label>
                                    <input
                                        type="varchar"
                                        name="Mobile"
                                        disabled={hasPendingRequest}
                                        value={formData.Mobile}
                                        onChange={handleChange}
                                        placeholder="Mobile No"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"

                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Fax No</label>
                                    <input
                                        type="number"
                                        name="Fax"
                                        disabled={hasPendingRequest}
                                        value={formData.Fax}
                                        onChange={handleChange}
                                        placeholder="Fax No"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Email Address</label>
                                    <input
                                        type="email"
                                        name="Email"
                                        disabled={hasPendingRequest}
                                        value={formData.Email}
                                        onChange={handleChange}
                                        placeholder="Primary Email Address"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"

                                    />
                                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Main email address that is primarily in use</p>
                                </div>





                                {/* <div className="flex items-start">
                                    <div className="flex items-center h-5">
                                        <input
                                            type="bit"
                                            name="SendToAllAddresses"
                                            checked={formData.sendToAllAddresses}
                                            onChange={handleChange}
                                            className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                        />
                                    </div>

                                </div> */}

                                {/* <div className="ml-3 text-sm">
                                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2 all available addresses?</label>
                                        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Tick if you would like to cc emails to all email addresses</p>
                                    </div> */}

                                {/* <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        name="unsubscribed"
                                        checked={ContactInfo.unsubscribed}
                                        onChange={(e) => handleChange(e, 'Contact')}
                                        className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                    />
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2-gray-700">Unsubscribed</label>
                                </div> */}

                                {/* <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Skype Username</label>
                                    <input
                                        type="text"
                                        name="skypeUsername"
                                        value={ContactInfo.skypeUsername}
                                        onChange={(e) => handleChange(e, 'Contact')}
                                        placeholder="Skype Username"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Website Address</label>
                                    <input
                                        type="text"
                                        name="websiteAddress"
                                        value={ContactInfo.websiteAddress}
                                        onChange={(e) => handleChange(e, 'Contact')}
                                        placeholder="Website Address"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                    />
                                </div> */}
                            </div>
                        </div>
                    )}

                    {activeTab === 'Local' && (
                        <div>
                            {/* Local Address Form */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Local Address Line 1</label>
                                    <input
                                        type="varchar"
                                        name="LocalAddressLine1"
                                        disabled={hasPendingRequest}
                                        value={formData.LocalAddressLine1}
                                        onChange={handleChange}
                                        placeholder="Address Line 1"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"

                                    />
                                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">First line of address, like steet number, building details, etc</p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Local Address Line 2</label>
                                    <input
                                        type="varchar"
                                        name="LocalAddressLine2"
                                        value={formData.LocalAddressLine2}
                                        disabled={hasPendingRequest}
                                        onChange={handleChange}
                                        placeholder="Address Line 2"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                    />
                                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Second line of address, such as steet name, landmarks, etc</p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Local Address Line 3</label>
                                    <input
                                        type="varchar"
                                        name="LocalAddressLine3"
                                        value={formData.LocalAddressLine3}
                                        disabled={hasPendingRequest}
                                        onChange={handleChange}
                                        placeholder="Address Line 3"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                    />
                                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Any additional Address details</p>
                                </div>




                                {/* <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Local Suburb / City</label>
                                    <input
                                        type="varchar"
                                        name="LSuburb"
                                        value={formData.LSuburb}
                                        onChange={handleChange}
                                        placeholder="Suburb / City"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"

                                    />

                                </div> */}

                                <div className='relative'>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Local Suburb / City</label>
                                    <input
                                        type="text"
                                        name="LSuburb"
                                        value={formData.LSuburb}
                                        disabled={hasPendingRequest}
                                        onChange={handleChange}
                                        placeholder="Suburb / City"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                    />
                                    {/* Suggestion Dropdown */}
                                    {showLocalSuggestions && localSuburbSuggestions.length > 0 && (
                                        <ul className="z-50 absolute border border-gray-300 rounded-md mt-1 max-h-40 overflow-auto bg-white dark:bg-neutral-800 shadow-md">
                                            {localSuburbSuggestions.map((suburb) => (
                                                <li
                                                    key={suburb.suburbID}
                                                    className="p-2 cursor-pointer hover:bg-gray-200 hover:dark:bg-white/20"
                                                    onClick={() => handleSuburbSelect(suburb, true)}
                                                >
                                                    {suburb.name}, {suburb.postCode}, {suburb.state}, {suburb.country}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>




                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">State</label>
                                    <input
                                        type="varchar"
                                        name="LState"
                                        value={formData.LState}
                                        onChange={handleChange}
                                        placeholder="State"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-gray-50 dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                        readOnly

                                    />


                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Postcode</label>
                                    <input
                                        type="varchar"
                                        name="LPostCode"
                                        value={formData.LPostCode}
                                        onChange={handleChange}
                                        placeholder="Postcode"
                                        autoComplete="off"
                                        className="block bg-gray-50 w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                        readOnly
                                    />

                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Country</label>
                                    <input
                                        type="varchar"
                                        name="LCountry"
                                        value={formData.LCountry}
                                        onChange={handleChange}
                                        placeholder='Country'
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-gray-50 dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                        readOnly
                                    />

                                </div>
                            </div>


                        </div>





                    )}

                    {activeTab === 'Mailing' && (
                        <div>
                            {/* Mailing Address Form */}
                            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6">


                                <div className="flex items-start mt-4 mb-6">
                                    <div className="flex items-center h-5">
                                        <input
                                            type="checkbox"
                                            name="copyLocalAddress"
                                            // checked={copyLocalAddress}
                                            // onChange={handleCopyLocalAddress}  
                                            className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                        />
                                    </div>
                                    <div className="ml-3 text-sm">
                                        <label htmlFor="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">
                                            Copy Local Address
                                        </label>
                                    </div>
                                </div> */}



                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Mailing Address Line 1</label>
                                    <input
                                        type="varchar"
                                        name="MailingAddressLine1"
                                        value={formData.MailingAddressLine1}
                                        onChange={handleChange}
                                        disabled={hasPendingRequest}
                                        placeholder="Address Line 1"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"

                                    />
                                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">First line of address, like steet number, building details, etc</p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Mailing Address Line 2</label>
                                    <input
                                        type="varchar"
                                        name="MailingAddressLine2"
                                        value={formData.MailingAddressLine2}
                                        disabled={hasPendingRequest}
                                        onChange={handleChange}
                                        placeholder="Address Line 2"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                    />
                                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Second line of address, such as steet name, landmarks, etc</p>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Mailing Address Line 3</label>
                                    <input
                                        type="varchar"
                                        name="MailingAddressLine3"
                                        value={formData.MailingAddressLine3}
                                        disabled={hasPendingRequest}
                                        onChange={handleChange}
                                        placeholder="Address Line 3"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                    />
                                    <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Any additional Address details</p>
                                </div>


                                {/* <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Mailing Suburb / City </label>
                                    <input
                                        type="varchar"
                                        name="MSuburb"
                                        value={formData.MSuburb}
                                        onChange={handleChange}
                                        placeholder="Suburb / City"
                                        className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"

                                    />
                                </div> */}

                                <div className='relative'>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Mailing Suburb / City</label>
                                    <input type="text" name="MSuburb" value={formData.MSuburb} onChange={handleChange} disabled={hasPendingRequest} placeholder="Suburb / City" autoComplete="off" className="block w-full px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 bg-white dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition" />
                                    {showMailingSuggestions && mailingSuburbSuggestions.length > 0 && (
                                        <ul className="z-50 absolute border border-gray-300 rounded-md mt-1 max-h-40 overflow-auto bg-white dark:bg-neutral-800 shadow-md">
                                            {mailingSuburbSuggestions.map((suburb) => (
                                                <li key={suburb.suburbID} className="p-2 cursor-pointer hover:bg-gray-200 hover:dark:bg-white/20" onClick={() => handleSuburbSelect(suburb, false)}>
                                                    {suburb.name}, {suburb.postCode}, {suburb.state}, {suburb.country}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>




                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">State</label>
                                    <input
                                        type="varchar"
                                        name="MState"
                                        value={formData.MState}
                                        onChange={handleChange}
                                        placeholder="State"
                                        autoComplete="off"
                                        className="block w-full bg-gray-50 px-3 py-1.5 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                        readOnly
                                    />


                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Postcode</label>
                                    <input
                                        type="varchar"
                                        name="MPostCode"
                                        value={formData.MPostCode}
                                        onChange={handleChange}
                                        placeholder="Postcode"
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 bg-gray-50 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                        readOnly
                                    />

                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Country</label>
                                    <input
                                        type="varchar"
                                        name="MCountry"
                                        value={formData.MCountry}
                                        onChange={handleChange}
                                        placeholder='Country'
                                        autoComplete="off"
                                        className="block w-full px-3 py-1.5 bg-gray-50 placeholder:text-sm dark:placeholder:text-gray-500 rounded-md border border-gray-300 dark:border-neutral-700 dark:bg-[#1f1f1f] text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-transparent transition"
                                        readOnly
                                    />

                                </div>


                            </div>
                        </div>

                    )}


                    <div className="mt-6 flex justify-end">
                        <button
                            type="submit"
                            disabled={hasPendingRequest}
                            className={`font-medium rounded-lg text-sm px-5 py-2 me-2.5 mb-2 text-white
                                ${hasPendingRequest
                                ? 'bg-gray-400 cursor-not-allowed dark:bg-[#2a2a2a] dark:hover:bg-[#3a3a3a] dark:text-white'
                                : 'bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-blue-500 dark:hover:bg-blue-600 dark:focus:ring-blue-300'
                                }`}
                            >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default EditAgentDetails;